"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Failable = void 0;
class Failable {
    static newSuccess(okResult) {
        return new Failable(okResult, null);
    }
    static newFailure(failMessage) {
        return new Failable(null, failMessage);
    }
    constructor(okResult, failMessage) {
        if (okResult === null && failMessage === null) {
            throw new Error('Cannot set both result and message to null');
        }
        this.okResult = okResult;
        this.failMessage = failMessage;
    }
    isOk() {
        return this.failMessage === null;
    }
    getValue() {
        // Must check isOK first
        if (this.okResult === null) {
            throw new Error('No value.  Failable is not okay' + this.failMessage);
        }
        return this.okResult;
    }
}
exports.Failable = Failable;
//# sourceMappingURL=Failable.js.map